import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpHelperService } from "@services/http-helper.service";
import {
  SecretQuestionResponse,
  UserResponse,
} from "@shared/interfaces/user.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public getUser(totken): Observable<Partial<UserResponse>> {
    const params = new HttpParams().set("token", totken);
    return this.httpHelperService.get("/auth/authenticate", params);
  }

  public getMenuAccess(userId: string): Observable<any> {
    return this.httpHelperService.get(`/user/menuaccess?userId=${userId}`);
  }

  public getUserAuthorization(): Observable<any> {
    return this.httpHelperService.get("/users/authorize");
  }

  public getSascEmailConfig(userId: string): Observable<any> {
    return this.httpHelperService.get(
      `/cn/approval/config?userId=${userId}`,
      new HttpParams(),
    );
  }

  public saveSascEmailConfig(body): Observable<any> {
    return this.httpHelperService.post(`/cn/approval/config`, body);
  }

  // The frontend always uses the canonical /auth/login path.
  // HttpHelperService.resolveBackendBaseUrl() transparently routes the request
  // to the local mock server or the real backend based on environment config.
  public login(body): Observable<any> {
    return this.httpHelperService.post("/auth/login", body);
  }

  public getsecretQuestion(userId): Observable<SecretQuestionResponse> {
    return this.httpHelperService.get(`/login/secretquestion?userId=${userId}`);
  }

  public submitValidationQuestion(body) {
    return this.httpHelperService.post(`/auth/login`, body);
  }

  public submitFirstTimeLogin(payload): Observable<any> {
    return this.httpHelperService.postWithOptions(
      "/login/profile/save",
      payload,
      {
        baseUrl: this.httpHelperService.resolveAlphaSatBaseUrl(),
      },
    );
  }

  public backToAlphaSubmission(userId): Observable<any> {
    return this.httpHelperService.get(
      `/session/logout?switch=true&menuId=CNGC_SUBMISSION_LIST&userId=${userId}`,
    );
  }
}
